/* istanbul ignore file */
export function fnQuickViewUspsDisplayCorrectionScript(queryParamKey) {
  const urlParams = new URLSearchParams(window.location.search);
  const ub = urlParams.get(queryParamKey);

  const hideUsps = uspNumbers => {
    uspNumbers.forEach(uspNumber => {
      document.body.style.setProperty(
        `--quick-view-usp-banner-${uspNumber}`,
        'none',
      );
    });
  };

  const displayCorrections = {
    1: () => hideUsps([2, 3, 4]),
    2: () => hideUsps([1, 3, 4]),
    3: () => hideUsps([1, 2, 4]),
    4: () => hideUsps([1, 2, 3]),
    hideAll: () => hideUsps([1, 2, 3, 4]),
  };
  if (displayCorrections[ub]) {
    displayCorrections[ub]();
  } else {
    displayCorrections.hideAll();
  }
}
